import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Close from '../assets/Close';
import Spinner from './Spinner';
import { db } from './Firebase';
import {
  setDoc,
  collection,
  getDocs,
  query,
  doc,
  where,
} from 'firebase/firestore';
import toast from 'react-hot-toast';
import { isValidEmail, toDateTime } from './Home';
import emailjs from '@emailjs/browser';
import { useNavigate } from 'react-router-dom';

const EMAILJS_SERVICE_ID = 'service_h4br5is';
const EMAILJS_PUBLIC_KEY = 'grg76XmeXnwqwv5cy';
const EMAILJS_BUSINESS_TEMPLATE = 'template_3bi0wub';
const EMAILJS_BOOKERDEVMAIL_TEMPLATE = 'template_stf18uq';

const Modal = ({ changeModal, modal }) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const colRef = collection(db, 'business_signups');
  const {
    businessemail,
    location,
    businessname,
    website,
    countrycode,
    phone,
    fullname,
  } = modal.data;

  useEffect(() => {
    const initializeEmailJS = async () => {
      try {
        emailjs.init(EMAILJS_PUBLIC_KEY);
        console.log('TheBooker Download Now!');
      } catch (error) {
        console.error('EmailJS initialization failed:', error);
      }
    };

    initializeEmailJS();
  }, []);

  const notValid =
    !businessemail.trim() ||
    !isValidEmail(businessemail) ||
    !location.trim() ||
    !businessname.trim() ||
    !countrycode.trim() ||
    !phone.trim() ||
    !fullname.trim();

  const signup = async () => {
    try {
      if (notValid) return;
      setLoading(true);
      const docSearch = await getDocs(
        query(colRef, where('email', '==', modal.data.businessemail))
      );
      if (docSearch.docs.length === 0) {
        await setDoc(doc(colRef), {
          email: businessemail,
          fullname: fullname,
          businessname: businessname,
          location: location,
          website: website ?? null,
          phone: `${countrycode}${phone}`,
          entry_date: toDateTime(),
        });
        emailjs
          .send(
            EMAILJS_SERVICE_ID,
            EMAILJS_BUSINESS_TEMPLATE,
            { name: fullname, email: businessemail },
            { publicKey: EMAILJS_PUBLIC_KEY }
          )
          .then(
            (response) => {
              console.log(response);
            },
            (error) => {
              console.log('Failed : ', error);
            }
          );
        // Email JS to Send to TheBookerDEV
        emailjs
          .send(
            EMAILJS_SERVICE_ID,
            EMAILJS_BOOKERDEVMAIL_TEMPLATE,
            {
              fullname,
              businessemail,
              businessname,
              location,
              phone,
              website: website ?? 'NA',
              entry_date: toDateTime(),
            },
            { publicKey: EMAILJS_PUBLIC_KEY }
          )
          .then(
            (response) => {
              console.log(response);
            },
            (error) => {
              console.log('Failed : ', error);
            }
          );

        //  toast.success("Thank you! We’ll be in touch with you soon!");
        //window.location.replace("/thanksbusiness");
        navigate('/thanksbusiness');
        document.body.style.overflow = 'visible';
        changeModal({
          show: false,
          data: {
            fullname: '',
            businessname: '',
            location: '',
            website: '',
            countrycode: '+961',
            phone: '',
            businessemail: '',
          },
        });
      } else {
        //console.log("Already exists");
        toast('Request already sent, We’ll be in touch with you soon!', {
          icon: '⚠️',
        });
        document.body.style.overflow = 'visible';
        setLoading(false);
        changeModal({
          show: false,
          data: {
            fullname: '',
            businessname: '',
            location: '',
            website: '',
            countrycode: '+961',
            phone: '',
            businessemail: '',
          },
        });
      }
    } catch (err) {
      toast.error('Request error');
      setLoading(false);
    } finally {
    }
  };

  return (
    <motion.div
      className='modal'
      initial={{ opacity: 0, scale: 1 }}
      animate={{
        opacity: 1,
        scale: modal.show ? 1 : 0.5,
        transition: { duration: 0.3, type: 'spring', stiffness: 300 },
      }}
      exit={{
        opacity: 0,
        scale: 0,
        transition: { duration: 0.1, type: 'inertia', stiffness: 300 },
      }}
      style={{
        visibility: modal.show ? 'visible' : 'hidden',
        opacity: modal.show ? '1' : '0',
      }}>
      <div>
        <h1>GROW YOUR BUSINESS WITH US!</h1>

        <div style={{ position: 'relative' }}>
          <div
            className='modal-x-btn'
            onClick={() => {
              document.body.style.overflow = 'visible';
              changeModal({
                show: false,
                data: {
                  fullname: '',
                  businessname: '',
                  location: '',
                  website: '',
                  countrycode: '+961',
                  phone: '',
                  businessemail: '',
                },
              });
            }}>
            <Close width={50} height={50} />
          </div>

          <div className='modal-main'>
            <div className='modal-row'>
              <div>
                <p>Full Name*</p>
                <input
                  maxLength={100}
                  type='text'
                  value={modal.data?.fullname}
                  onChange={(e) =>
                    changeModal({
                      ...modal,
                      data: modal.data
                        ? { ...modal.data, fullname: e.target.value }
                        : null,
                    })
                  }
                />
              </div>

              <div>
                <p>Business Name*</p>
                <input
                  maxLength={100}
                  type='text'
                  value={modal.data?.businessname}
                  onChange={(e) =>
                    changeModal({
                      ...modal,
                      data: modal.data
                        ? { ...modal.data, businessname: e.target.value }
                        : null,
                    })
                  }
                />
              </div>
            </div>

            <div className='modal-row' style={{ marginTop: 25 }}>
              <div>
                <p>Location*</p>
                <input
                  type='text'
                  maxLength={250}
                  value={modal.data?.location}
                  onChange={(e) =>
                    changeModal({
                      ...modal,
                      data: modal.data
                        ? { ...modal.data, location: e.target.value }
                        : null,
                    })
                  }
                />
              </div>

              <div>
                <p>Website</p>
                <input
                  type='text'
                  maxLength={250}
                  value={modal.data?.website}
                  onChange={(e) =>
                    changeModal({
                      ...modal,
                      data: modal.data
                        ? { ...modal.data, website: e.target.value }
                        : null,
                    })
                  }
                />
              </div>
            </div>

            <div className='modal-row' style={{ marginTop: 25 }}>
              <div>
                <p>Phone Number*</p>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                  }}>
                  <select
                    value={modal.data?.countrycode}
                    onChange={(e) =>
                      changeModal({
                        ...modal,
                        data: modal.data
                          ? { ...modal.data, countrycode: e.target.value }
                          : null,
                      })
                    }
                    style={{ width: '20%' }}>
                    <option>+961</option>
                  </select>
                  <input
                    type='tel'
                    maxLength={8}
                    style={{ width: '78%' }}
                    value={modal.data?.phone}
                    onChange={(e) =>
                      changeModal({
                        ...modal,
                        data: modal.data
                          ? {
                              ...modal.data,
                              phone: e.target.value.replace(/\D/g, ''),
                            }
                          : null,
                      })
                    }
                  />
                </div>
              </div>

              <div>
                <p>Business Email*</p>
                <input
                  maxLength={100}
                  type='email'
                  value={modal.data?.businessemail}
                  onChange={(e) =>
                    changeModal({
                      ...modal,
                      data: modal.data
                        ? { ...modal.data, businessemail: e.target.value }
                        : null,
                    })
                  }
                />
              </div>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 30,
              }}>
              {!loading ? (
                <div
                  onClick={() => (notValid ? null : signup())}
                  className='subscribe-btn'
                  style={{
                    marginTop: 15,
                    backgroundColor: 'white',
                    color: '#008a80',
                    opacity: notValid ? 0.5 : 1,
                  }}>
                  <p
                    style={{
                      color: '#008a80',
                      margin: 0,
                      fontFamily: 'Hurme-Bold',
                    }}>
                    SUBMIT
                  </p>
                </div>
              ) : (
                <Spinner />
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Modal;
